import axios from "axios";

// Points at the new NestJS API (api/) instead of the legacy Node API. The new
// API has no "Api-Key" concept — just the bearer JWT — so that header is gone.
const URL_API = process.env.REACT_APP_SERVER_HOST || "/";

axios.interceptors.request.use((reConfig) => {
  const auth = localStorage.getItem("token");
  reConfig.headers = auth ? { authorization: "Bearer " + auth } : {};
  reConfig.baseURL = URL_API;
  return reConfig;
},
  (error) => {
    return Promise.reject(error)
  }
);

axios.interceptors.response.use(
  (response) =>
    response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error)
  }
);
